import { Components } from 'src/components';
import { setComponentAttributes } from 'shared/storybook-utils';

export default {
  title: 'Components/Indicator',
  component: 'a1-indicator',
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: 'Partial Component - Notification Indicator.',
      },
    },
    layout: 'centered',
  },
};

const elementName = 'a1-indicator';

const Template = (args: Components.A1Indicator): HTMLElement => {
  const elComponent = document.createElement(elementName);

  Object.entries(args).forEach(([key, value]) => {
    setComponentAttributes({ element: elComponent, key, value });
  });

  return elComponent;
};

export const Critical: Story<Components.A1Indicator> = Template.bind({});
Critical.args = {
  count: 123,
};

export const Warning: Story<Components.A1Indicator> = Template.bind({});
Warning.args = {
  ...Critical.args,
  type: 'warning',
};

export const Positive: Story<Components.A1Indicator> = Template.bind({});
Positive.args = {
  ...Critical.args,
  type: 'positive',
};

export const Info: Story<Components.A1Indicator> = Template.bind({});
Info.args = {
  ...Critical.args,
  type: 'info',
};

export const NoCounter: Story<Components.A1Indicator> = Template.bind({});
NoCounter.args = {
  ...Critical.args,
  count: 0,
};

export const MaxDigits: Story<Components.A1Indicator> = Template.bind({});
MaxDigits.args = {
  ...Critical.args,
  count: 1450,
  maxDigits: 3,
};
